module.exports = __webpack_public_path__ + "static/media/plugOff_326.919cac87.png";